module.exports = __webpack_public_path__ + "img/ic_river.15b04d34.svg";